import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, IconButton,
  Dialog, DialogTitle, DialogContent, Grid, TextField, DialogActions, FormControl, InputLabel, Select,
  MenuItem, DialogContentText
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../../services/api';


const Usuarios = () => {
  const [users, setUsers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [usuarioAtual, setUsuarioAtual] = useState({ nome: '', email: '', ativo: 'S', nivel: 0, senha: '', confirmacaoSenha: '' });
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [erroSenha, setErroSenha] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [ativoFilter, setAtivoFilter] = useState('S');

  useEffect(() => {
    handleFilterChange();
  }, []);

  const handleFilterChange = () => {
    // Construir o objeto de filtros com os valores atuais
    const ativoValue = ativoFilter === "Todos" ? "" : ativoFilter;
    const filters = {
        ativo: ativoValue,
    };
    // Fazer uma nova requisição ao backend com os filtros aplicados
    fetchUsers(filters);
};

  const fetchUsers = async (filters = {}) => {
    try {
      const response = await api.get(`/users`, { params: filters });
      setUsers(response.data);
    } catch (error) {
      console.error('Erro ao buscar usuários', error);
    }
  };


  // Abrir modal para novo usuário
  const handleAddClick = () => {
    setUsuarioAtual({ nome: '', email: '', ativo: 'S', nivel: 0, senha: '', confirmacaoSenha: '' });
    setIsEditMode(false);
    setOpenEditDialog(true);
  };

  // Abrir modal para editar usuário
  const handleEditClick = (usuario) => {
    setUsuarioAtual({ ...usuario, confirmacaoSenha: usuario.senha });
    setIsEditMode(true);
    setOpenEditDialog(true);
  };

  // Valida se a senha e a confirmação de senha são iguais
  const validarSenhas = () => {
    if (usuarioAtual.senha !== usuarioAtual.confirmacaoSenha) {
      setErroSenha(true);
      return false;
    }
    setErroSenha(false);
    return true;
  };

  const validarEmail = () => {
    const retorno = validateEmail(usuarioAtual.email);
    if (!retorno) {
      window.alert('Email inválido, digite novamente!');
    }
    return retorno

  }

  // Salvar ou editar o usuário
  const handleSaveUsuario = async () => {
    if (!validarSenhas()) {
      return; // Não prossegue se as senhas não forem iguais
    }

    if (!validarEmail()) {
      return;
    }

    if (isEditMode) {
      try {
        await api.put(`/users/${usuarioAtual.id}`, usuarioAtual);
        fetchUsers(); // Atualizar a lista
      } catch (error) {
        console.error('Erro ao atualizar usuário', error);
      }
    } else {
      try {
        await api.post('/users', usuarioAtual);
        fetchUsers(); // Atualizar a lista
      } catch (error) {
        console.error('Erro ao criar usuário', error);
      }
    }

    setOpenEditDialog(false);
    setUsuarioAtual({ nome: '', email: '', ativo: 'S', nivel: 0, senha: '', confirmacaoSenha: '' });
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUsuarioAtual({ ...usuarioAtual, [name]: value });
  };

  // Função para deletar o usuário
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setOpenDialog(true); // Abre o diálogo de confirmação
  };

  // Confirmar exclusão
  const handleConfirmDelete = async () => {
    console.log(deleteId);
    try {
      await api.delete(`/users/${deleteId}`);
      fetchUsers();
      setUsers(users.filter(usuario => usuario.id !== deleteId));
      setOpenDialog(false);
      setDeleteId(null);
    } catch (error) {
      console.error('Erro ao excluir usuário', error);
    }
  };

  // Cancelar exclusão
  const handleCancelDelete = () => {
    setOpenDialog(false);
    setDeleteId(null);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    setUsuarioAtual({ ...usuarioAtual, email: e.target.value.toLowerCase() });
    if (validateEmail(e.target.value)) {
      setEmailError(false);
      return true
    } else {
      setEmailError(true);
      return false
    }
  };

  return (
    <div style={{ marginTop: 80 }}>

      <TableContainer component={Paper} sx={{ maxWidth: '80%', margin: 'auto' }}>
      <Grid container alignItems="center" justifyContent="space-between" sx={{ marginTop: 2}}>
                    {/* Botão INCLUIR alinhado à esquerda */}
                    <Grid item>
                        <Button variant="contained"
                            onClick={handleAddClick}
                            sx={{ width: 80, marginBottom: 2, marginTop:2, backgroundColor: 'red', color: 'white', '&:hover': { backgroundColor: 'darkred' } }}>
                            INCLUIR
                        </Button>
                    </Grid>

                    {/* Filtro e botão de aplicar filtros alinhados à direita */}
                    <Grid item>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                            
                                <FormControl sx={{ minWidth: 150 }} fullWidth>
                                <InputLabel id="ativo-label" sx={{ fontSize: '1rem', color: 'black'}}>Ativo?</InputLabel>
                                    <Select
                                        labelId="ativo-label"
                                        value={ativoFilter}
                                        onChange={(e) => setAtivoFilter(e.target.value)}
                                        label="Ativo?"
                                    >
                                        <MenuItem value="N">Não</MenuItem>
                                        <MenuItem value="S">Sim</MenuItem>
                                        <MenuItem value="Todos">Todos</MenuItem>
                                    </Select>
                                    
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" onClick={handleFilterChange}>
                                    APLICAR FILTROS
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
       
        <Table>
          <TableHead sx={{ backgroundColor: 'red' }}>
            <TableRow>
              <TableCell sx={{ color: 'white' }}>ID</TableCell>
              <TableCell sx={{ color: 'white' }}>Email</TableCell>
              <TableCell sx={{ color: 'white' }}>Ativo</TableCell>
              <TableCell sx={{ color: 'white' }}>Nível</TableCell>
              <TableCell sx={{ color: 'white' }}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id} >
                <TableCell>{user.id}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.ativo}</TableCell>
                <TableCell>{user.nivel}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEditClick(user)}><EditIcon /></IconButton>
                  <IconButton onClick={() => handleDeleteClick(user.id)}><DeleteIcon /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>


      {/* Diálogo de confirmação de exclusão */}
      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <DialogContentText>Você tem certeza que deseja excluir este usuário?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">Cancelar</Button>
          <Button onClick={handleConfirmDelete} color="secondary">Excluir</Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo de inclusão/edição de usuário */}
      <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
        <DialogTitle>{isEditMode ? 'Editar Usuário' : 'Novo Usuário'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ mt: 2 }}>
              <TextField
                label="Email"
                name="email"
                value={usuarioAtual.email}
                onChange={handleEmailChange}
                fullWidth
                error={emailError}
                helperText={emailError ? 'Por favor, insira um email válido.' : ''}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="ativo-label">Ativo</InputLabel>
                <Select
                  labelId="ativo-label"
                  name="ativo"
                  value={usuarioAtual.ativo}
                  onChange={handleInputChange}
                  label="Ativo"
                >
                  <MenuItem value="S">Sim</MenuItem>
                  <MenuItem value="N">Não</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Nível"
                name="nivel"
                value={usuarioAtual.nivel}
                onChange={handleInputChange}
                type="number"
                fullWidth
                inputProps={{ min: 0, max: 3 }}  // Limita o nível entre 0 e 3
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Senha"
                name="senha"
                value={usuarioAtual.senha}
                onChange={handleInputChange}
                type="password"
                fullWidth
                inputProps={{ maxLength: 10 }}  // Limita a senha a 10 caracteres
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Confirmação de Senha"
                name="confirmacaoSenha"
                value={usuarioAtual.confirmacaoSenha}
                onChange={handleInputChange}
                type="password"
                fullWidth
                error={erroSenha} // Exibe erro se as senhas não forem iguais
                helperText={erroSenha ? 'As senhas não coincidem' : ''}
                inputProps={{ maxLength: 10 }}  // Limita a confirmação de senha a 10 caracteres
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)} color="primary">Cancelar</Button>
          <Button onClick={handleSaveUsuario} color="primary">Salvar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Usuarios;
